import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { isAuth, isEmailVerified, permissionsUpdated, permissionsUpdating, updatePermissions, permissionsError, verifyJwt } from '../authSlice';
import { Navigate } from 'react-router-dom';
import { selectedUser } from '../authSlice';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { StripeProvider } from '../../../context/StripeContext';

const PrivateRoute = ({ page }: { page: JSX.Element }) => {
    const { isLoading } = useAppSelector(selectedUser);
    const isAuthenticated = useAppSelector(isAuth);
    const isEmailStatusClean = useAppSelector(isEmailVerified);
    const permissionsHasError = useAppSelector(permissionsError);
    const permissionsLoaded = useAppSelector(permissionsUpdated);
    const permissionsLoading = useAppSelector(permissionsUpdating);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(verifyJwt());

        if (permissionsHasError) {
            return;
        }
        if (isAuthenticated && !permissionsLoaded && !permissionsLoading) {
            dispatch(updatePermissions())
        }
    }, [dispatch, isAuthenticated, permissionsLoaded, permissionsLoading, permissionsHasError]);

    const AuthPageWithcontext = <StripeProvider>{page}</StripeProvider>

    if (isLoading || permissionsLoading)
        return (
            <div className="vh-100">
                <div className="h-100 d-flex d-column justify-content-center align-items-center">
                    <SmashSpinner />
                </div>
            </div>
        );

    if (isAuthenticated && isEmailStatusClean) {
        return AuthPageWithcontext
    } else if (isAuthenticated && !isEmailStatusClean) {
        return <Navigate replace to='/email-verification' />
    } else {
        // Not authenticated: send to the public home, where the user chooses Log in (portal) or Sign up.
        return <Navigate replace to='/login' />
    }
}

export default PrivateRoute